var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        _vm._g(
          _vm._b(
            {
              attrs: {
                visible: _vm.value,
                beforeClose: _vm.close,
                "close-on-click-modal": false,
                "modal-append-to-body": false,
              },
            },
            "el-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "el-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "el-form",
                {
                  ref: "elForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选项名", prop: "label" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入选项名",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.label,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "label", $$v)
                              },
                              expression: "formData.label",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isData
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "选项值", prop: "extraValue" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入选项值",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData.extraValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "extraValue", $$v)
                                  },
                                  expression: "formData.extraValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handelConfirm },
                },
                [_vm._v("\n                确定\n            ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [
                _vm._v("\n                取消\n            "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }